'use client';

const GoogleMap = () => {
  return (
    <div className="h-[80vh] w-full text-right">
      <div className="gmap_canvas h-[80vh] w-full overflow-hidden border-4 border-white bg-none shadow">
        <iframe
          className="gmap_iframe h-[80vh] w-full"
          src="https://maps.google.com/maps?width=600&height=400&hl=en&q=Rehab%20Solutions%20Physiotherapy%20&amp;%20Wellness%20Centre/%20Best%20Physiotherapy%20Centre%20in%20Dhaka+(Rehab%20Solutions)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default GoogleMap;
